import controller from '../../Controller.js';
function SavedCoursesController(container) {

    const savedCoursesKey = container.dataset.courseStorageId ?? "courses";
     
    function init() {

        // Add class to course if it is saved.
        updateCourseSavedStatusClass();

        attatchEventListeners();

        function getStoredCourses() {
            return localStorage.getItem(savedCoursesKey); 
        }

        function setStoredCourses(value) {
            localStorage.setItem(savedCoursesKey, JSON.stringify(value));
        }

        function saveCourseId() {
            let courses = getStoredCourses();
            if (courses) {
                courses = JSON.parse(courses);
                if (!courses.includes(container.dataset.courseId)) {
                    courses.push(container.dataset.courseId);
                }
            } else {
                courses = [container.dataset.courseId];
            }

            setStoredCourses(courses);

            updateCoursesCountDisplay();
        }

        function removeCourseId() {
            let courses = getStoredCourses();
            if (courses) {
                courses = JSON.parse(courses);
                courses = courses.filter(id => id !== container.dataset.courseId);
                setStoredCourses(courses);
            }

            updateCoursesCountDisplay();
        }

        function isCourseIdSaved() {
            const courses = getStoredCourses();
            if (courses) {
                return JSON.parse(courses).includes(container.dataset.courseId);
            }
            return false;
        }

        function countSavedCourseIds() {
            const courses = getStoredCourses();
            return courses ? JSON.parse(courses).length : 0;
        }

        function updateCoursesCountDisplay() {
            const count = countSavedCourseIds();
            const displayElements = document.querySelectorAll('#saved-courses-count');

            displayElements.forEach(function (element) {
                element.textContent = count;
            });
        }


        function attatchEventListeners() {

            var removeButton = container.querySelector('#remove-saved-course');
            if (removeButton) {
                removeButton.addEventListener('click', function () {
                    removeCourseId(container.dataset.courseId);

                    updateCourseSavedStatusClass();
                    updateCoursesCountDisplay();
                });
            }

            var saveButton = container.querySelector('#toggle-save-course');
            if (saveButton) {
                saveButton.addEventListener('click', function (event) {
                    event.preventDefault();

                    if (isCourseIdSaved(container.dataset.courseId)) {
                        removeCourseId(container.dataset.courseId);
                    }
                    else {
                        saveCourseId(container.dataset.courseId);
                    }

                    updateCourseSavedStatusClass()

                    updateCoursesCountDisplay();

                });

                // Mark the button as having an event listener attached
                // To prevent attaching the event listener multiple times when fetching new content
                saveButton.setAttribute('data-listener-attached', 'true');
            }

        }

        function updateCourseSavedStatusClass() {
            var saveButtonElement = container.querySelector('#toggle-save-course');
            var svgElements = saveButtonElement.querySelectorAll('svg');

            if (isCourseIdSaved(container.dataset.courseId)) {
                svgElements.forEach(function (svg) {
                    svg.classList.add('icon--filled-currentColor');
                });

            } else {
                svgElements.forEach(function (svg) {
                    svg.classList.remove('icon--filled-currentColor');
                });
            }
        };

    }

    return {
        init: init
    }

}

controller.add('SavedCoursesController', SavedCoursesController);
export default SavedCoursesController;
